import { z } from 'zod';

export const emailModalValidation = z.object({
  email: z.string().min(1, {message: 'Введите email'}).email('Некорректный email'),
});

export type EmailModalData = z.infer<typeof emailModalValidation>;
